// import ACTION_TYPES from 'profilePage/actions/actionTypes';

export default function filterOptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var resp = arguments.length > 1 ? arguments[1] : undefined;
  return state;
}